import type { XMediaPartialType } from '@/components/pages/content/types';

import { X } from '@/lib/socialProfile';

import Post from '@/components/base/Post';
import LazyAnalyticsFooter from '@/components/base/Post/LazyAnalyticsFooter';

type TwitterPostFooterProps = {
    hasFooter?: boolean;
    shouldUseLazyAnalytics: boolean;
    data?: XMediaPartialType;
    type: string | null;
};

export const TwitterPostFooter = ({
    hasFooter,
    shouldUseLazyAnalytics,
    data,
    type
}: TwitterPostFooterProps) => {
    if (!hasFooter) {
        return null;
    }

    const useLazyAnalytics = shouldUseLazyAnalytics && data?.id && data?.social_profile_id;

    if (useLazyAnalytics) {
        return (
            <LazyAnalyticsFooter
                type={type}
                mediaId={data.id}
                socialProfileId={data.social_profile_id}
                network={X}
            />
        );
    }

    return <Post.Footer type={type} />;
};
